/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Offerhover_Features1Inputs */

const id_home_offerhover_features1 = /** @type {(inputs: Home_Offerhover_Features1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fitur:`)
};

const ms_home_offerhover_features1 = /** @type {(inputs: Home_Offerhover_Features1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciri:`)
};

const da_home_offerhover_features1 = /** @type {(inputs: Home_Offerhover_Features1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktioner:`)
};

const de_home_offerhover_features1 = /** @type {(inputs: Home_Offerhover_Features1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktionen:`)
};

const en_us2_home_offerhover_features1 = /** @type {(inputs: Home_Offerhover_Features1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Features:`)
};

const es_es2_home_offerhover_features1 = /** @type {(inputs: Home_Offerhover_Features1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Características:`)
};

const es_mx2_home_offerhover_features1 = /** @type {(inputs: Home_Offerhover_Features1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Características:`)
};

const fil_home_offerhover_features1 = /** @type {(inputs: Home_Offerhover_Features1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Tampok:`)
};

const fr_home_offerhover_features1 = /** @type {(inputs: Home_Offerhover_Features1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonctionnalités :`)
};

const it_home_offerhover_features1 = /** @type {(inputs: Home_Offerhover_Features1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caratteristiche:`)
};

const hu_home_offerhover_features1 = /** @type {(inputs: Home_Offerhover_Features1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funkciók:`)
};

const nl_home_offerhover_features1 = /** @type {(inputs: Home_Offerhover_Features1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kenmerken:`)
};

const no_home_offerhover_features1 = /** @type {(inputs: Home_Offerhover_Features1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funksjoner:`)
};

const pl_home_offerhover_features1 = /** @type {(inputs: Home_Offerhover_Features1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funkcje:`)
};

const pt_br2_home_offerhover_features1 = /** @type {(inputs: Home_Offerhover_Features1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Características:`)
};

const pt_home_offerhover_features1 = /** @type {(inputs: Home_Offerhover_Features1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funcionalidades:`)
};

const ro_home_offerhover_features1 = /** @type {(inputs: Home_Offerhover_Features1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caracteristici:`)
};

const fi_home_offerhover_features1 = /** @type {(inputs: Home_Offerhover_Features1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ominaisuudet:`)
};

const sv_home_offerhover_features1 = /** @type {(inputs: Home_Offerhover_Features1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktioner:`)
};

const vi_home_offerhover_features1 = /** @type {(inputs: Home_Offerhover_Features1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tính năng:`)
};

const tr_home_offerhover_features1 = /** @type {(inputs: Home_Offerhover_Features1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Özellikler:`)
};

const cs_home_offerhover_features1 = /** @type {(inputs: Home_Offerhover_Features1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funkce:`)
};

const bg_home_offerhover_features1 = /** @type {(inputs: Home_Offerhover_Features1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Функции:`)
};

const ru_home_offerhover_features1 = /** @type {(inputs: Home_Offerhover_Features1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Особенности:`)
};

const uk_home_offerhover_features1 = /** @type {(inputs: Home_Offerhover_Features1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Особливості:`)
};

const ar_home_offerhover_features1 = /** @type {(inputs: Home_Offerhover_Features1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الميزات:`)
};

const hi_home_offerhover_features1 = /** @type {(inputs: Home_Offerhover_Features1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विशेषताएँ:`)
};

const th_home_offerhover_features1 = /** @type {(inputs: Home_Offerhover_Features1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณสมบัติ:`)
};

const ja_home_offerhover_features1 = /** @type {(inputs: Home_Offerhover_Features1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`特徴：`)
};

const zh_cn2_home_offerhover_features1 = /** @type {(inputs: Home_Offerhover_Features1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`特色功能:`)
};

const zh_hant1_home_offerhover_features1 = /** @type {(inputs: Home_Offerhover_Features1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`特色功能：`)
};

const ko_home_offerhover_features1 = /** @type {(inputs: Home_Offerhover_Features1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`특징:`)
};

/**
* | output |
* | --- |
* | "Features:" |
*
* @param {Home_Offerhover_Features1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_offerhover_features1 = /** @type {((inputs?: Home_Offerhover_Features1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Offerhover_Features1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_offerhover_features1(inputs)
	if (locale === "ms") return ms_home_offerhover_features1(inputs)
	if (locale === "da") return da_home_offerhover_features1(inputs)
	if (locale === "de") return de_home_offerhover_features1(inputs)
	if (locale === "en-US") return en_us2_home_offerhover_features1(inputs)
	if (locale === "es-ES") return es_es2_home_offerhover_features1(inputs)
	if (locale === "es-MX") return es_mx2_home_offerhover_features1(inputs)
	if (locale === "fil") return fil_home_offerhover_features1(inputs)
	if (locale === "fr") return fr_home_offerhover_features1(inputs)
	if (locale === "it") return it_home_offerhover_features1(inputs)
	if (locale === "hu") return hu_home_offerhover_features1(inputs)
	if (locale === "nl") return nl_home_offerhover_features1(inputs)
	if (locale === "no") return no_home_offerhover_features1(inputs)
	if (locale === "pl") return pl_home_offerhover_features1(inputs)
	if (locale === "pt-BR") return pt_br2_home_offerhover_features1(inputs)
	if (locale === "pt") return pt_home_offerhover_features1(inputs)
	if (locale === "ro") return ro_home_offerhover_features1(inputs)
	if (locale === "fi") return fi_home_offerhover_features1(inputs)
	if (locale === "sv") return sv_home_offerhover_features1(inputs)
	if (locale === "vi") return vi_home_offerhover_features1(inputs)
	if (locale === "tr") return tr_home_offerhover_features1(inputs)
	if (locale === "cs") return cs_home_offerhover_features1(inputs)
	if (locale === "bg") return bg_home_offerhover_features1(inputs)
	if (locale === "ru") return ru_home_offerhover_features1(inputs)
	if (locale === "uk") return uk_home_offerhover_features1(inputs)
	if (locale === "ar") return ar_home_offerhover_features1(inputs)
	if (locale === "hi") return hi_home_offerhover_features1(inputs)
	if (locale === "th") return th_home_offerhover_features1(inputs)
	if (locale === "ja") return ja_home_offerhover_features1(inputs)
	if (locale === "zh-CN") return zh_cn2_home_offerhover_features1(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_offerhover_features1(inputs)
	return ko_home_offerhover_features1(inputs)
});
export { home_offerhover_features1 as "home.offerHover.features" }